import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCheckCallScheduleList extends Layout {
    layoutheaderC: LayoutHeader;
    sourceCheckCallSched: DataSource;
    tableSchedules: Table;
}
